/**
 * Helper class to index a string with a number if the value was used before.
 */
export class IndexName {
    constructor() { }
    static next(name) {
        let current_id = IndexName._ids.get(name);
        if (current_id !== undefined) {
            current_id++;
            return IndexName.index_name(name, current_id);
        }
        return IndexName.index_name(name, 0);
    }
    static index_name(name, index) {
        IndexName._ids.set(name, index);
        return index === 0 ? name : `${name} (${index})`;
    }
}
IndexName._ids = new Map();
/**
 * Indexes a `string` property/accessor with a number if the value was used before.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function Indexed(target, property_key, descriptor) {
    return descriptor ? indexed_accessor(target, property_key, descriptor) : indexed_property(target, property_key);
}
const indexed = new WeakMap();
function indexed_property(target, property_key) {
    const getter = function () {
        var _a;
        return (_a = indexed.get(this)) !== null && _a !== void 0 ? _a : '';
    };
    const setter = function (new_value) {
        var _a;
        const current = (_a = indexed.get(this)) !== null && _a !== void 0 ? _a : '';
        if (current === new_value)
            return;
        indexed.set(this, IndexName.next(new_value));
    };
    Object.defineProperty(target, property_key, {
        get: getter,
        set: setter,
        enumerable: true,
        configurable: true
    });
}
function indexed_accessor(target, property_key, descriptor) {
    const original_setter = descriptor.set;
    descriptor.set = function (value) {
        if (descriptor.get && descriptor.get.call(this) === value)
            return;
        original_setter.call(this, IndexName.next(value));
    };
}
//# sourceMappingURL=IndexedName.js.map